import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { iDeath } from '../death.interface';
import { MagImageComponent } from '@app/features/medias/mag-image/mag-image.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { SharedModule } from '@app/shared/shared.module';
import { AdsModule } from '@app/shared/ads.module';

@Component({
  selector: 'app-dead-view',
  standalone: true,
  imports: [
		SharedModule,
		ProgressBarModule,
		MagImageComponent,
		AdsModule,
	],
	encapsulation: ViewEncapsulation.None,
  templateUrl: './dead-view.component.html',
  styleUrl: './dead-view.component.scss'
})
export class DeadViewComponent implements OnInit {
	@Input() dead!:iDeath;
	public showWinnerList:boolean = false;
	public winnerList: string[] = [];

	public ageBase:number = 100;
	public ageProgress?: number;

	public pointsBase: number = 70;
	public pointsProgress?: number;

	public winnersBase: number = 20;
	public winnersProgress?: number;

	ngOnInit(): void {
		this.ageProgress = this.dead.age/this.ageBase*100;
		this.pointsProgress = this.dead.points/this.pointsBase*100;
		this.winnersProgress = this.dead.winners/this.winnersBase*100;
		this.winnerListManage();
	}

	private winnerListManage(): void {
		const winners = this.dead.winnersList;
		if(!winners || winners.length == 0) {
			this.showWinnerList = false;
			return;
		}
		this.winnerList = winners.map((w: any) => {
			return `${w["name"].toLowerCase()} - ${w["location"]}`;
		});
		this.showWinnerList = true;
	}

	public acertador(): string {
		return this.dead.winners.toString() + " " + (this.dead.winners == 1 ? "acertador" : "acertadores");
	}

}
